/**
 * Global singleton to manage signature block timestamp updates
 * This avoids issues with multiple ProposalBuilderWrapper instances
 */
class SignatureBlockTimestampManager {
	private static instance: SignatureBlockTimestampManager;
	private updateFunction: ((blockId: string) => void) | null = null;

	private constructor() {}

	public static getInstance(): SignatureBlockTimestampManager {
		if (!SignatureBlockTimestampManager.instance) {
			SignatureBlockTimestampManager.instance =
				new SignatureBlockTimestampManager();
		}
		return SignatureBlockTimestampManager.instance;
	}

	public setUpdateFunction(fn: (blockId: string) => void): void {
		this.updateFunction = fn;
	}

	public updateTimestamp(blockId: string): void {
		if (this.updateFunction) {
			this.updateFunction(blockId);
		}
	}

	public hasUpdateFunction(): boolean {
		return this.updateFunction !== null;
	}
}

export default SignatureBlockTimestampManager;
